import React,{useState,useEffect,useCallback} from 'react';
import {RouteComponentProps, Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import useReactRouter from 'use-react-router';
import Modal from '@material-ui/core/Modal';
import {Tools} from './Tools';
import {Styles} from './Styles';
import Header from './Header';
import Result from './Result';
import Ajax from './Ajax';

interface RCProps extends RouteComponentProps<{gid?:string}> {
	
}

interface Props {
    
}

let gid:string;

const Enter = (props:Props)=> {
    const classes = Styles.base();
    const [isModalOpen,setIsModalOpen] = useState(false);
    const [isRedirect,setIsRedirect] = useState(false);
    const [play,setPlay] = useState();

    const rcp:RCProps = useReactRouter();
	if( rcp.match.params.gid ){
		gid = rcp.match.params.gid;
	} else {
		gid = "";
	}

    const handleModalClose = ()=>{
        setIsModalOpen(false);
        setIsRedirect(true);
    };

    const load = useCallback(()=>{
        Ajax.send("play/get",{gid:gid},(res:any)=>{
            if( res.ok ){
                setPlay(res.play);
                setIsModalOpen(true);
            } else {
                setIsRedirect(true);
            }
        })
    },[]);

    const goTop = ()=>{
    }
  
    const goGuide = ()=>{
    }

    const close = ()=>{
        setIsRedirect(true);
    }


    useEffect( ()=>{
        load();
    },[load]);

    if( isRedirect ){
        return (
            <Redirect to="/"/>
        );
    }

	return (
		<div id="enter">
            <Header top={goTop} guide={goGuide}/>
			<Modal
				aria-labelledby="simple-modal-title"
				aria-describedby="simple-modal-description"
				open={isModalOpen}
				onClose={handleModalClose}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                    <Result play={play} close={close}/>
	    		</div>
			</Modal>
		</div>
	);
}

export default Enter;
